import { useMemo } from 'react';

import { useDefaultParams } from '~/hooks/useDefaultParams';
import type { SearchParamsWithDefault } from '~/utils/search/types';

export const useJobFiltersTrackedValues = (
  searchParams: SearchParamsWithDefault | undefined,
  totalJobOffers: number | undefined,
) => {
  const defaultParams = useDefaultParams();

  return useMemo(
    () => ({
      job: searchParams?.job,
      city: searchParams?.address?.name,
      distance: {
        default: searchParams?.distance === defaultParams.distance,
        value: searchParams?.distance,
      },
      experience: searchParams?.experience,
      sort: {
        default: searchParams?.sort === defaultParams.sort,
        value: searchParams?.sort,
      },
      type: searchParams?.type,
      resultsNumber: totalJobOffers,
      pageNumber: searchParams?.page,
    }),
    [searchParams, defaultParams],
  );
};
